import { updateRaiseWorkOrderDetails } from "actions/updateRaiseWorkOrderDetails";
import { updateCompleteWorkOrderPageOrigination } from "actions/updateCompleteWorkOrderPageOrigination";

import { updateViewWorkOrderPageOrigination } from "actions/updateViewWorkOrderPageOrigination";
import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import { useStateMachine } from "little-state-machine";
import { Breadcrumb } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";

const CompleteWorkOrderBreadcrumb = () => {
  const { state } = useStateMachine();
  const navigate = useNavigate();
  const {
    id, source, sourceType, sourceId
  } = useParams();
  const { actions } = useStateMachine({
    updateRaiseWorkOrderDetails,
    updateViewWorkOrderPageOrigination,
    updateCompleteWorkOrderPageOrigination
  });
  const [origin, setOrigin] = useState<string>("");
  const [originLabel, setOriginLabel] = useState<string>("");
  const [linkToOrigin, setLinkToOrigin] = useState<string>("");

  const navigateToViewWorkOrder = (): void => {
    actions.updateViewWorkOrderPageOrigination(state.viewCompleteWorkOrderPageOrigination);

    switch (state.viewCompleteWorkOrderPageOrigination) {
      case RoutePathsEnum.Map:
        navigate(`${RoutePathsEnum.WorkOrderView}/${id}/${source}/${sourceType}/${sourceId}`);
        break;
      case RoutePathsEnum.WorkOrders:
      case RoutePathsEnum.Containers:
      default:
        navigate(`${RoutePathsEnum.WorkOrderView}/${id}`);
        break;
    }
  };

  useEffect(() => {
    switch (state.viewCompleteWorkOrderPageOrigination) {
      case RoutePathsEnum.Map:
        setOrigin("maps");
        setOriginLabel("Map");
        setLinkToOrigin(`${state.viewCompleteWorkOrderPageOrigination}/${source}/${sourceType}/${sourceId}`);
        break;
      case RoutePathsEnum.WorkOrders:
        setOrigin("work-orders");
        setOriginLabel("Work Orders");
        setLinkToOrigin(`${state.viewCompleteWorkOrderPageOrigination}`);
        break;
      case RoutePathsEnum.Containers:
        setOrigin("container");
        setOriginLabel("Container Status");
        setLinkToOrigin(`${state.viewCompleteWorkOrderPageOrigination}`);
        break;
      default:
        break;
    }
  }, [setOrigin, setOriginLabel]);

  return (
    <Breadcrumb className="left-margin-large no-wrap">
      <Breadcrumb.Item
        data-testid={`breadcrumb-${origin}`}
        linkAs={Link}
        linkProps={{
          to: linkToOrigin
        }}
        onClick={() => navigate(linkToOrigin)}
      >
        {originLabel}
      </Breadcrumb.Item>

      <Breadcrumb.Item
        data-testid={`breadcrumb-${origin}-view-work-order`}
        linkAs={Link}
        linkProps={{
          to: RoutePathsEnum.WorkOrderView
        }}
        onClick={navigateToViewWorkOrder}
      >
        View Work Order
      </Breadcrumb.Item>

      <Breadcrumb.Item data-testid="breadcrumb-complete-work-order" active>
        Complete Work Order
      </Breadcrumb.Item>
    </Breadcrumb>
  );
};

export default CompleteWorkOrderBreadcrumb;
